<div class="overlay-page" *ngIf="loading">
    <div class="loading-box">
        <!--<div class="loading-img"><img src="assets/images/load-logo.png"></div>-->
        <div class="spinner-border text-white " role="status"></div>
    </div>
</div>

<div class="navbar p-0 pl-3 top-navbar">
    <div class="col-md-2 brand-logo npm"><img src="assets/images/logo.jpeg"></div>
    <!--<div class="col-md-2 brand-logo npm"><img src="assets/images/mpma.jpeg"></div>-->
    <div class="col-md-10 npm">
        <!-- <ul class="navbar-nav ml-auto ml-md-0 text-right pr-3 user-con">

            <li class="nav-item dropdown user-box ">
                <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false"> <span class="smt-avatar"> <img
                            src="assets/images/avatar-9.jpg" width="36" height="36"> </span>
                    <span class="user-name">User Name</span>
                </a>



                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                    <a class="dropdown-item" href="changepassword.html"> <span class="la la-wrench smt-icon"
                            aria-hidden="true"></span> <span>Change Password</span> </a>
                    <a class="dropdown-item" href="login.html"> <span class="la la-sign-out smt-icon"
                            aria-hidden="true"></span> <span>Logout</span> </a>
                </div>

            </li>

        </ul> -->
    </div>
</div>
<!--Topbar End-->


<nav class="navbar navbar-expand-sm navbar-light bg-green p-0 text-center">
    <div class="collapse navbar-collapse pl-2 pt-1 pr-2 text-center" id="nav-content">
        <div class="col-md-4 text-center">
            <h6><strong><i class="la la-phone"></i> Office Number : Ms Chong - 076522288</strong></h6>
        </div>
        <div class="col-md-8 text-left">
            <h6><strong><i class="la la-envelope-o"></i> For any enquiries related to your purchases, please email our
                    customers service center @ Mychong@lsspi.com</strong></h6>
        </div>


    </div>
</nav>

<!--Navigation-->
<!-- <nav class="navbar navbar-expand-sm navbar-light bg-faded p-0">

    <div class="collapse navbar-collapse pl-2  pr-2" id="nav-content">
        <ul class="navbar-nav">

            <li class="nav-item">
                <a class="nav-link" href="dashboard.html"><i class="la la-dashboard"></i> Dashboard</a>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="Preview" href="#" role="button"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="la la-money"></i> Manage Order</a>
                <div class="dropdown-menu" aria-labelledby="Preview">
                    <a class="dropdown-item" href="purchase-order.html"> <i class="la la-money"></i> Purchase
                        Order</a>
                </div>
            </li>






        </ul>
    </div> 

</nav>-->
<!--Navigation End-->


<section>
    <div class="row bs-wizard col-md-12">

        <div class="col-sm-6 bs-wizard-step complete">
            <div class="progress">
                <div class="progress-bar"></div>
            </div>
            <a href="#" class="bs-wizard-dot"></a>
            <div class="bs-wizard-info text-center">Purchase order</div>
        </div>


        <div class="col-sm-6 bs-wizard-step active">
            <!-- complete -->
            <div class="progress">
                <div class="progress-bar"></div>
            </div>
            <a href="#" class="bs-wizard-dot"></a>
            <div class="bs-wizard-info text-center">Confirm Order</div>
        </div>

        <!--<div class="col-sm-4 bs-wizard-step disabled">
            <div class="progress">
                <div class="progress-bar"></div>
            </div>
            <a href="#" class="bs-wizard-dot"></a>
            <div class="bs-wizard-info text-center">Deliver Address</div>
        </div>-->
    </div>
</section>

<div class="content-sec">
    <div class="col-md-12 p-0">
        <div class="card content-box" *ngIf="deliveryForm">





            <div class="card-header">
                <h3><i class="la la-money"></i> CONFIRM ORDER</h3>
            </div>

            <h6>Delivery Details</h6>
            <div class="col-md-12" *ngIf="deliveryForm">
                <form [formGroup]="deliveryForm">

                    <div class="row mt-4">

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Name</label>
                            <i class="la la-user"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Enter Name"
                                formControlName="name">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('name').valid && deliveryForm.get('name').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Street/Unit no</label>
                            <i class="la la-map"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Street / Unit no"
                                formControlName="address">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('address').valid && deliveryForm.get('address').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">State</label>
                            <i class="la la-map-pin"></i>
                            <select class="form-control transparent-tb" placeholder="Enter State"
                                formControlName="state" (change)="setDeliveryCharge($event)">
                                <option value="">Select</option>
                                <option *ngFor="let stateObj of statesList" value="{{stateObj.state}}">
                                    {{stateObj.state}}</option>
                            </select>
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('state').valid && deliveryForm.get('state').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Postcode / Town</label>
                            <i class="la la-map-pin"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Postcode / Town"
                                formControlName="pincode">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('pincode').valid && deliveryForm.get('pincode').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Phone Number</label>
                            <i class="la la-phone"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Enter Phone Number"
                                formControlName="phone">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('phone').valid && deliveryForm.get('phone').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Email</label>
                            <i class="la la-envelope-o"></i>
                            <input type="email" class="form-control transparent-tb" placeholder="Email" email
                                formControlName="email">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('email').valid  && deliveryForm.get('email').touched && deliveryForm.get('email').errors.Required">Required
                                Field</small>
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('email').valid  && deliveryForm.get('email').touched && deliveryForm.get('email').errors.email">Not
                                a valid email address</small>
                        </div>

                    </div>
                </form>
            </div>

            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <table class="table res-table reflow-table">
                        <thead>
                            <tr>
                                <th width="100">Product</th>
                                <th>Product Description</th>
                                <th style="width:200px" class="text-right">Quantity</th>
                                <th style="width:200px" class="text-right">Price</th>
                                <th style="width:200px" class="text-right">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let orderItem of confirmOrderList">
                                <td width="100">
                                    <div class="media ">
                                        <a class="thumbnail pull-right " href="#">
                                            <!--<img class="media-object" src="assets/images/product-icon.png">-->
                                            <img class="media-object" [src]="orderItem.itemImageUrl | safe:'url'">
                                        </a>
                                    </div>
                                </td>
                                <td colspan="5">
                                    <div class="media">
                                        <a href="javascript:void(0)">
                                            <div class="media-body ">
                                                <h4 class="media-heading">{{orderItem.itemName}}</h4>
                                                <h5 class="media-heading"> {{orderItem.itemType}}</h5>
                                                <small>Status: </small><small
                                                    class="text-success">{{orderItem.itemStatus}}</small>
                                            </div>
                                        </a>

                                        <div style="width: 100%;">
                                            <table class="table inner-tbl res-table reflow-table">
                                                <ng-container *ngFor="let itemChoice of orderItem.itemChoices">
                                                    <tr *ngIf="itemChoice.isChecked">
                                                        <td></td>
                                                        <td>
                                                            {{itemChoice.itemChoiceName}}
                                                        </td>
                                                        <td style="width:200px" class="text-right">
                                                            {{itemChoice.itemChoiceQuantity}}</td>
                                                        <td style="width: 200px" class="text-right">RM
                                                            {{itemChoice.itemChoicePrice}} </td>
                                                        <td style="width: 200px" class="text-right">RM
                                                            {{itemChoice.itemChoiceTotalPrice}} </td>
                                                    </tr>
                                                </ng-container>

                                            </table>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>   </td>
                                <td>   </td>
                                <td>   </td>
                                <td class="text-right">
                                    <h5> Order Value </h5>
                                </td>
                                <td class="text-right"><strong>RM {{cartValue | number: '1.2-2'}}</strong></td>
                            </tr>
                            <tr>
                                <td>   </td>
                                <td>   </td>
                                <td>   </td>
                                <td class="text-right">
                                    <h5> Delivery Charge </h5>
                                </td>
                                <td class="text-right"><strong>RM {{deliveryCharge}}</strong></td>
                            </tr>
                            <tr>
                                <td>   </td>
                                <td>   </td>
                                <td>   </td>
                                <td class="text-right">
                                    <h5>Subtotal Amount Due</h5>
                                </td>
                                <td class="text-right">
                                    <h5><strong>RM {{subTotalvalue | number: '1.2-2'}}</strong></h5>
                                </td>
                            </tr>


                        </tbody>
                    </table>
                </div>
            </div>


            <div class="col-md-12">
                <div class="row">

                    <div class="clearfix"></div>
                    <div class="col-lg-8 col-md-12 col-sm-12 form-group icon-form mr-auto">
                        <strong> Do the payment transfer to below Account Number and upload the
                            receipt</strong><br><br>
                        <strong> RHB Bank Bhd</strong><br>
                        <strong> Account no :</strong> 20103500022991<br>
                        LEE SOON SENG PLASTIC INDUSTRIES SDN BHD<br>
                    </div>

                    <div class="col-lg-4 col-md-12 col-sm-12 form-group icon-form ml-auto">
                        <label class="label">upload Payment Receipt</label>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile"
                                (change)="handleReceiptFile($event)">
                            <label class="custom-file-label" for="customFile">Choose file</label>
                        </div>
                        <small class="form-text text-danger" *ngIf="!uploadContentFile">Mandatory Document</small>
                        <small class="form-text text-primary text-center"
                            *ngIf="uploadContentFile">{{uploadContentFile.name}} [{{uploadContentFileSize}} MB]</small>
                        <div class="text-center">
                            <progress max="100" *ngIf="uploadContentFile" [value]="(uploadProgress | async)"></progress>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-12 col-sm-12 form-group icon-form ml-auto" *ngIf="isIncludesSchoolMask">
                        <label class="label">School Name</label>
                        <i class="la la-building"></i>
                        <input type="text" class="form-control transparent-tb" placeholder="Enter School Name"
                            [(ngModel)]="schoolName">
                        <small class="form-text text-danger">Mandatory Field</small>

                        <div class="clearfix mb-2"></div>
                        <label class="label">upload School Certificate or PIBG</label>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="customFile"
                                (change)="handleSchoolCertFile($event)">
                            <label class="custom-file-label" for="customFile">Choose file</label>
                        </div>
                        <small class="form-text text-danger" *ngIf="!uploadCertFile">Mandatory Document</small>
                        <small class="form-text text-primary text-center" *ngIf="uploadCertFile">{{uploadCertFile.name}}
                            [{{uploadCertFile}} MB]</small>
                        <div class="text-center">
                            <progress max="100" *ngIf="uploadCertFile"
                                [value]="(uploadCertProgress | async)"></progress>
                        </div>
                    </div>

                </div>
            </div>

            <hr>

            <div class="col-md-12">


                <div class="text-right mt-3 mb-4">
                    <button type="button" class="btn btn-primary"
                        [disabled]="deliveryForm.invalid || !uploadContentFile || (isIncludesSchoolMask && (!schoolName || schoolName == '' || !uploadCertFile))"
                        (click)="submitOrder()">Submit</button>
                    <button type="button" class="btn btn-success" (click)="cancelOrder()">Cancel</button>
                </div>
                <div class="text-center">
                    <h6><strong class="text-secondary"><span class="text-danger">SCGM BHD</span> would like to apologize
                            for any late deliveries due to overwhelming response of our face mask.
                            We endeavour to do our best. In case of any issues, please email to our customer service as
                            mentioned above.</strong></h6>
                </div>
            </div>

        </div>
    </div>
</div>


<div class="col-md-12">
    <div class="text-center mt-3">
        Powered by : <a href="https://zastainfotek.com/" target="_blank">ZastaInfotek</a>
    </div>
</div>




<ng-template #successModal let-modal>
    <div class="modal-content modal-confirm">
        <div class="modal-header">
            <div class="icon-box">
                <i class="ft-check"></i>
            </div>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
        </div>
        <div class="modal-body text-center">
            <h4>Success</h4>
            <p class="text-success">Order submitted successfully !!</p>
            <button class="btn btn-success" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
    </div>
</ng-template>

<ng-template #errorModal let-modal>
    <div class="modal-content modal-reject ">
        <div class="modal-header">
            <div class="icon-box">
                <i class="ft-alert-triangle"></i>
            </div>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
        </div>
        <div class="modal-body text-center">
            <h4>Failure</h4>
            <p class="text-danger">Error while submitting order. Please try again.</p>
            <button class="btn btn-success" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
    </div>
</ng-template>